import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
function lazyLoad(view) {
  return () => import(`@/module/candidate/pages/${view}/${view}.vue`)
}
export default [
  { path: '/individualSignup', component: lazyLoad('jobseekerSignUp') },
  { path: '/individualPreReg', component: lazyLoad('jobseekerPreReg') },
  {
    path: '/profile', component: lazyLoad('editProfile')
  },
  {
    path: '/candidateSearch', component: lazyLoad('candidateSearch')
  },
  {
    path: '/savedCandidates', component: lazyLoad('savedCandidates')
  },
  {
    path: '/candidateProfiles', component: lazyLoad('candidateProfiles')
  },
  {
    path: '/gigJobs', component: lazyLoad('gigJobs')
  },
  {
    path: '/individualLogin', component: lazyLoad('jobseekerLogin')
  },
  // {
  //   path: '/appliedJobs', component: lazyLoad('appliedJobs')
  // },
  {
    path: '/resetPasswordForJobseeker/:mailtoken', component: lazyLoad('resetPasswordForJobseeker')
  }, {
    path: '/individualDashboard', component: lazyLoad('jobseekerDashboard')
  }, {
    path: '/courseSearch', component: lazyLoad('courseSearch')
  }, {
    path: '/courseHistoryForIndividual', component: lazyLoad('courseHistoryForJobseeker')
  },{
    path: '/employeeCourseHistory', component: lazyLoad('courseHistoryForJobseeker')
  },{
    path: '/candidateChat', component: lazyLoad('candidateChat')
  }
  ,{
    path: '/indiCourse', component: lazyLoad('indiCourseDetails')
  }, {
    path: '/archivedCourseSearch', component: lazyLoad('archivedCourseSearch')
  }, {
    path: '/satelliteEventSearch', component: lazyLoad('satelliteEventSearch')
  }
]